import React, { useEffect, useState } from "react";
import Navigation from "./components/Navigation";
import Hero from "./components/Hero";
import Gallery from "./components/Gallery";
import WhereWeAre from "./components/WhereWeAre";
import About from "./components/About";
import Services from "./components/Services";
import Testimonials from "./components/Testimonials";
import Booking from "./components/Booking";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import ConsentBanner from "./components/ConsentBanner";
import LegalModal from "./components/LegalModal";
import ScrollProgress from "./components/ScrollProgress";
import { useConsent } from "./lib/useConsent";
import { loadAnalytics } from "./lib/analytics";
import JsonData from "./data/data.json";
import ReviewsData from "./data/reviews.json";
import "./styles/theme.css";

const App = () => {
  const { consent, decided, save, acceptAll, rejectAll } = useConsent();
  const [legal, setLegal] = useState(null);
  const [showBanner, setShowBanner] = useState(false);

  // Show the banner only once we know there is no stored decision.
  useEffect(() => {
    if (!decided) setShowBanner(true);
  }, [decided]);

  // Load analytics only when consent exists and allows it.
  useEffect(() => {
    if (consent.analytics) loadAnalytics();
  }, [consent.analytics]);

  const handleSave = (categories) => {
    save(categories);
    setShowBanner(false);
  };

  const handleAcceptAll = () => {
    acceptAll();
    setShowBanner(false);
  };

  const handleRejectAll = () => {
    rejectAll();
    setShowBanner(false);
  };

  return (
    <>
      <ScrollProgress />
      <Navigation />

      <main id="main">
        <Hero data={JsonData.Header} rating={ReviewsData.airbnb} />
        <Gallery data={JsonData.Gallery} />
        <WhereWeAre consent={consent} onAllowMap={() => save({ ...consent, external: true })} />
        <About data={JsonData.About} />
        <Services airbnbUrl={ReviewsData.airbnb?.url} />
        <Testimonials data={ReviewsData} />
        <Booking data={JsonData.Booking} reviews={ReviewsData} />
        <Contact data={JsonData.Contact} onOpenPrivacy={() => setLegal("privacy")} />
      </main>

      <Footer onOpenLegal={setLegal} onOpenCookieSettings={() => setShowBanner(true)} />

      {showBanner && (
        <ConsentBanner
          onSave={handleSave}
          onAcceptAll={handleAcceptAll}
          onRejectAll={handleRejectAll}
          onOpenPrivacy={() => setLegal("privacy")}
        />
      )}

      <LegalModal page={legal} onClose={() => setLegal(null)} />
    </>
  );
};

export default App;
